/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EStyle } from '../../../types';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './AppIcon.styles';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IconProps {
  icon: IconProp;
  color?: string;
  css?: EStyle;
}

const Icon: React.FC<IconProps> = ({ icon, color, css }) => {
  const iconStyles = useStyles(styleFn);

  const combinedCss = color ? [css, iconStyles[color]] : [css];
  return <FontAwesomeIcon icon={icon} css={combinedCss} />;
};

export default Icon;
